module.exports = __webpack_public_path__ + "static/media/B5.4fbddd1e.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/B5.png
// module id = 884
// module chunks = 0